<template>
    <div class="row justify-center items-center" style="height: 80vh;" >
        <div class="col-xs-12 col-sm-5">
            <q-card>
                <q-card-main>
                    <vue-plyr ref="plyr" :options="{ listeners: { seek: activity.user_watch ? '' : seekVideo } }">
                        <audio playsinline ref="player">
                            <source :src="`${getResource}#t=${activity.current_time}`" :type="$mime.lookup(activity.resource)">
                        </audio>
                    </vue-plyr>
                </q-card-main>
            </q-card>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'dashjs'

export default {
    props: ['activity', 'closing'],

    data() {
        return {
            id_course: '',
            interval: null,
            current_time: 0,
            total_time: '',
            changed_time: false,
            id_trail: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getResource() {
            if (this.activity.offline_path) return this.activity.offline_path
            else if (this.activity.resource) return this.activity.resource
            else return ''
        },

        player () { return this.$refs.plyr.player }
    },

    methods: {
        sendPosition() {
            if (this.current_time != 0) {
                let fd = new FormData()
                fd.append('current_time', this.current_time)
                fd.append('total_time', this.total_time)
                fd.append('id_group_training_module', this.activity.type_id)
                
                let url = ''
                if (this.id_trail == "") {
                    url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
                }
                else {
                    url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`
                }


                this.$axios.post(url, fd, this.getHeader)
                .then(response => {

                })
                .catch(e => {
                    console.log(e)
                })
            }
        },

        playVideo() {
            if (!this.changed_time) {
                this.player.currentTime = this.activity.current_time
                this.changed_time = true
            }

            this.interval = setInterval(() => {
                this.sendPosition()
            }, 60000)
        },

        pauseVideo() {
            this.sendPosition()
            clearInterval(this.interval)
        },

        videoTimeUpdated(val) {
            this.current_time = val.detail.plyr.currentTime
        },

        metaData(val) {
            this.total_time = val.detail.plyr.media.duration
        },

        seekVideo(e) {

        }
    },

    watch: {
        closing: function(val) {
            if (val == true) {
                this.sendPosition()
                clearInterval(this.interval)
                this.changed_time = false
                this.$emit('positionSent')
            }
        }
    },

    mounted () {
        this.player.on('timeupdate', (val) => this.videoTimeUpdated(val))
        this.player.on('loadedmetadata', (val) => this.metaData(val))
        this.player.on('play', (val) => this.playVideo())
        this.player.on('pause', (val) => this.pauseVideo())
    },

    created() {
        if( this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
        if( this.$route.params.id) this.id_course = this.$route.params.id
    }
}
</script>

<style lang="stylus" scoped>

</style>
